export const categoryMap = {
      tenant: 'lease',
      landlord: 'lease',
      buyer: 'sale',
      seller: 'sale',
      consulting: 'consulting',
      other: 'other',
    };
